<button
  type="button"
  [attr.aria-label]="title || null"
  [attr.aria-disabled]="disabled || loading()"
  [disabled]="disabled || loading()"
  (click)="click($event)"
  (keydown)="onKeydown($event)"
  class="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-transparent transition-colors hover:bg-slate-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-1"
  [ngClass]="{
    'cursor-pointer': !disabled && !loading(),
    'cursor-not-allowed opacity-50': disabled || loading()
  }"
>
  @if (loading()) {
    <i
      class="fa-light fa-spinner-third animate-spin text-xs text-slate-600"
    ></i>
  } @else {
    <i
      [class]="displayIcon() + ' text-xl'"
      [sntTooltip]="title"
      [ngStyle]="iconStyle()"
      aria-hidden="true"
    ></i>
  }
</button>
